import { AutomationStepType, type AutomationFlowStepPayload } from '@/data/models/domain/automations/types'

/**
 * Transforms IDs to strings
 */
export const transformAutomationFlowStepPayload = (value: unknown): AutomationFlowStepPayload<AutomationStepType> => {
  if (!value || typeof value !== 'object' || !('type' in value)) {
    return value as AutomationFlowStepPayload<AutomationStepType>
  }

  const typedValue = value as Record<string, unknown>

  if (typedValue.type === AutomationStepType.ACTION_CREATE_NEW_DEAL) {
    return {
      ...typedValue,
      pipelineId: typedValue.pipelineId ? String(typedValue.pipelineId) : null,
      dealStageId: typedValue.dealStageId ? String(typedValue.dealStageId) : null,
    } as AutomationFlowStepPayload<AutomationStepType.ACTION_CREATE_NEW_DEAL>
  }

  if (typedValue.type === AutomationStepType.ACTION_CREATE_NEW_TASK) {
    return {
      ...typedValue,
      boardId: typedValue.boardId ? String(typedValue.boardId) : null,
      stageId: typedValue.stageId ? String(typedValue.stageId) : null,
    } as AutomationFlowStepPayload<AutomationStepType.ACTION_CREATE_NEW_TASK>
  }

  if (typedValue.type === AutomationStepType.ACTION_SEND_EMAIL) {
    return {
      ...typedValue,
      replyToEmail: typedValue.replyToEmail === '' ? null : typedValue.replyToEmail,
    } as AutomationFlowStepPayload<AutomationStepType.ACTION_SEND_EMAIL>
  }

  return value as AutomationFlowStepPayload<AutomationStepType>
}
